import { cn } from '@/utils/ui/styles'

import type { ComponentProps } from 'react'

export const Section = ({
	children,
	className,
	...props
}: ComponentProps<'div'>) => {
	return (
		<div className="h-full w-full" {...props}>
			<div
				className={cn(
					'flex h-full flex-col items-start justify-start',
					className,
				)}
			>
				<div className="flex h-full w-full flex-col gap-4 p-6">{children}</div>
			</div>
		</div>
	)
}

export const SectionTitle = ({
	children,
	className,
}: {
	children: React.ReactNode
	className?: string
}) => {
	return <h1 className={cn('text-3xl font-bold', className)}>{children}</h1>
}

export const SectionDescription = ({
	children,
	className,
}: {
	children: React.ReactNode
	className?: string
}) => {
	return (
		<p className={cn('text-muted-foreground text-sm', className)}>{children}</p>
	)
}
